export const ourProducts = [
    {
      title: 'Travel Management and Booking Platforms', 
      subtitle:
        'Simplify travel planning with our comprehensive Travel Management and Booking Platforms. From flights and accommodations to activities, our platform ensures a seamless and efficient travel booking experience.',
      img: 'url(/industries/travel/travel-management-and-booking-platforms.avif)',
      content:
        'From flights and accommodations to activities, our platform ensures a seamless and efficient travel booking experience with our Travel Management and Booking Platforms.',
      link: '/industries/travel/products/travel-management-and-booking-platforms',
    },
    {
      title: 'AI-Powered Travel Recommender Systems',
      subtitle:
        'Elevate your travel experience with personalized recommendations using AI-Powered Travel Recommender Systems. Discover tailored suggestions for destinations, activities, and accommodations based on your preferences.',
      img: 'url(/industries/travel/ai-powered-travel-recommender-systems.jpg)',
      content:
        'Discover tailored suggestions for destinations, activities, and accommodations based on your preferences with our AI-Powered Travel Recommender Systems.',
      link: '/industries/travel/products/ai-powered-travel-recommender-systems',
    },
    {
      title: 'Virtual Reality Travel Experiences',
      subtitle:
        'Immerse yourself in the world of travel with Virtual Reality Travel Experiences. Explore destinations virtually, preview accommodations, and plan your trips with an unprecedented level of detail and realism.',
      img: 'url(/industries/travel/virtual-reality-travel-experiences.jpg)',
      content:
        'Explore destinations virtually, preview accommodations, and plan your trips with an unprecedented level of detail and realism with our Virtual Reality Travel Experiences.',
      link: '/industries/travel/products/virtual-reality-travel-experiences',
    },
    {
      title: 'Online Travel Agency (OTA) Software',
      subtitle:
        'Empower your travel agency with our Online Travel Agency Software. Streamline booking processes, provide real-time information, and enhance customer satisfaction through a user-friendly and efficient online platform.',
      img: 'url(/industries/travel/online-travel-agency-software.jpg)',
      content:
        'Streamline booking processes, provide real-time information, and enhance customer satisfaction through a user-friendly and efficient online platform with our Online Travel Agency (OTA) Software.',
      link: '/industries/travel/products/online-travel-agency-software',
    },
    {
      title: 'Dynamic Pricing and Revenue Management Systems for Travel',
      subtitle:
        'Maximize revenue with Dynamic Pricing and Revenue Management Systems for Travel. Optimize pricing strategies, adapt to market trends, and ensure profitability in a dynamic and competitive travel industry.',
      img: 'url(/industries/travel/dynamic-pricing-and-revenue-management-systems-for-travel.jpg)',
      content:
        'Optimize pricing strategies, adapt to market trends, and ensure profitability in a dynamic and competitive travel industry with our Dynamic Pricing and Revenue Management Systems for Travel.',
      link: '/industries/travel/products/dynamic-pricing-and-revenue-management-systems-for-travel',
    },
    {
      title: 'Travel Expense Management and Reporting Tools',
      subtitle:
        'Streamline expense tracking with Travel Expense Management and Reporting Tools. Simplify reimbursement processes, ensure compliance, and gain insights into travel-related expenditures for efficient financial management.',
      img: 'url(/industries/travel/travel-expense-management-and-reporting-tools.jpg)',
      content:
        'Simplify reimbursement processes, ensure compliance, and gain insights into travel-related expenditures for efficient financial management with our Travel Expense Management and Reporting Tools.',
      link: '/industries/travel/products/travel-expense-management-and-reporting-tools',
    },
    {
      title: 'Aviation Crew Management and Scheduling Software',
      subtitle:
        'Ensure smooth airline operations with Aviation Crew Management and Scheduling Software. Optimize crew schedules, manage resources efficiently, and enhance overall operational effectiveness in the aviation industry.',
      img: 'url(/industries/travel/aviation-crew-management-and-scheduling-software.avif)',
      content:
        'Optimize crew schedules, manage resources efficiently, and enhance overall operational effectiveness in the aviation industry with our Aviation Crew Management and Scheduling Software.',
      link: '/industries/travel/products/aviation-crew-management-and-scheduling-software',
    },
    {
      title: 'Hotel Property Management Systems (PMS)',
      subtitle:
        'Elevate hotel management with our Hotel Property Management Systems. Streamline reservations, manage guest information, and enhance overall guest experiences with an integrated and efficient PMS.',
      img: 'url(/industries/travel/hotel-property-management-systems.jpg)',
      content:
        'Streamline reservations, manage guest information, and enhance overall guest experiences with an integrated and efficient PMS with our Hotel Property Management Systems (PMS).',
      link: '/industries/travel/products/hotel-property-management-systems',
    },
    {
      title: 'Destination Management and Tourism Promotion Platforms',
      subtitle:
        'Promote destinations effectively with Destination Management and Tourism Promotion Platforms. Showcase attractions, coordinate events, and engage with travelers to boost tourism and local economies.',
      img: 'url(/industries/travel/destination-management-and-tourism-promotion-platforms.jpg)',
      content:
        'Showcase attractions, coordinate events, and engage with travelers to boost tourism and local economies with our Destination Management and Tourism Promotion Platforms.',
      link: '/industries/travel/products/destination-management-and-tourism-promotion-platforms',
    },
    {
      title: 'Mobile Applications for Travel Itinerary Planning',
      subtitle:
        'Plan your travel itinerary effortlessly with Mobile Applications designed for travel planning. Access real-time information, customize your itinerary, and stay organized throughout your journey.',
      img: 'url(/industries/travel/mobile-applications-for-travel-itinerary-planning.jpg)',
      content:
        'Access real-time information, customize your itinerary, and stay organized throughout your journey with our Mobile Applications for Travel Itinerary Planning.',
      link: '/industries/travel/products/mobile-applications-for-travel-itinerary-planning',
    },
    {
      title: 'Augmented Reality Navigation and Exploration Apps',
      subtitle:
        'Navigate and explore with Augmented Reality Navigation Apps. Enhance your travel experience by overlaying digital information on the physical world, providing informative and interactive guidance.',
      img: 'url(/industries/travel/augmented-reality-navigation-and-exploration-apps.avif)',
      content:
        'Enhance your travel experience by overlaying digital information on the physical world, providing informative and interactive guidance with our Augmented Reality Navigation and Exploration Apps.',
      link: '/industries/travel/products/augmented-reality-navigation-and-exploration-apps',
    },
    {
      title: 'Sustainable Tourism Impact Assessment Software',
      subtitle:
        'Embrace sustainable tourism with Impact Assessment Software. Evaluate and mitigate the environmental and social impact of travel activities to foster responsible tourism practices.',
      img: 'url(/industries/travel/sustainable-tourism-impact-assessment-software.jpg)',
      content:
        'Evaluate and mitigate the environmental and social impact of travel activities to foster responsible tourism practices with our Sustainable Tourism Impact Assessment Software.',
      link: '/industries/travel/products/sustainable-tourism-impact-assessment-software',
    },
    {
      title: 'Event Management Software for Conferences and Expos',
      subtitle:
        'Organize successful events with our Event Management Software. Streamline registration, coordinate logistics, and enhance attendee experiences for conferences, expos, and other travel-related events.',
      img: 'url(/industries/travel/event-management-software-for-conferences-and-expos.avif)',
      content:
        'Streamline registration, coordinate logistics, and enhance attendee experiences for conferences, expos, and other travel-related events with our Event Management Software.',
      link: '/industries/travel/products/event-management-software-for-conferences-and-expos',
    },
    {
      title: 'Cruise Management and Reservation Systems',
      subtitle:
        'Cruise smoothly through the booking process with Cruise Management and Reservation Systems. Streamline reservations, manage passenger information, and enhance the overall cruise experience for travelers.',
      img: 'url(/industries/travel/cruise-management-and-reservation-systems.jpg)',
      content:
        'Streamline reservations, manage passenger information, and enhance the overall cruise experience for travelers with our Cruise Management and Reservation Systems.',
      link: '/industries/travel/products/cruise-management-and-reservation-systems',
    },
    {
      title: 'Airport Operations and Security Management Software',
      subtitle:
        'Ensure efficient airport operations with our Airport Operations and Security Management Software. Streamline security processes, optimize resource allocation, and enhance overall airport security and efficiency.',
      img: 'url(/industries/travel/airport-operations-and-security-management-software.jpg)',
      content:
        'Streamline security processes, optimize resource allocation, and enhance overall airport security and efficiency with our Airport Operations and Security Management Software.',
      link: '/industries/travel/products/airport-operations-and-security-management-software',
    },
    {
      title: 'Loyalty Program Management Solutions for Travel',
      subtitle:
        'Reward and retain customers with Loyalty Program Management Solutions for Travel. Implement personalized loyalty programs, offer exclusive benefits, and enhance customer engagement in the travel industry.',
      img: 'url(/industries/travel/loyalty-program-management-solutions-for-travel.jpg)',
      content:
        'Implement personalized loyalty programs, offer exclusive benefits, and enhance customer engagement in the travel industry with our Loyalty Program Management Solutions for Travel.',
      link: '/industries/travel/products/loyalty-program-management-solutions-for-travel',
    },
    {
      title: 'Reservation and Booking Software for Tours and Activities',
      subtitle:
        'Simplify tour and activity bookings with our Reservation and Booking Software. Provide a user-friendly platform for travelers to discover, book, and enjoy a variety of tours and activities.',
      img: 'url(/industries/travel/reservation-and-booking-software-for-tours-and-activities.jpg)',
      content:
        'Provide a user-friendly platform for travelers to discover, book, and enjoy a variety of tours and activities with our Reservation and Booking Software.',
      link: '/industries/travel/products/reservation-and-booking-software-for-tours-and-activities',
    },
    {
      title: 'Global Distribution System (GDS) Integration Platforms',
      subtitle:
        'Connect seamlessly with Global Distribution Systems through our Integration Platforms. Expand your reach, streamline distribution, and ensure real-time availability across various travel channels.',
      img: 'url(/industries/travel/gds-integration-platforms.jpg)',
      content:
        'Expand your reach, streamline distribution, and ensure real-time availability across various travel channels with our Global Distribution System (GDS) Integration Platforms.',
      link: '/industries/travel/products/gds-integration-platforms',
    },
    {
      title: 'Travel Insurance Management Systems',
      subtitle:
        'Safeguard your travel with Travel Insurance Management Systems. Streamline the insurance process, offer personalized coverage, and ensure travelers have peace of mind throughout their journeys.',
      img: 'url(/industries/travel/travel-insurance-management-systems.jpg)',
      content:
        'Streamline the insurance process, offer personalized coverage, and ensure travelers have peace of mind throughout their journeys with our Travel Insurance Management Systems.',
      link: '/industries/travel/products/travel-insurance-management-systems',
    },
    {
      title: 'AI-Enhanced Language Translation Apps for Travelers',
      subtitle:
        'Break language barriers with AI-Enhanced Language Translation Apps. Empower travelers to communicate effectively, navigate foreign environments, and immerse themselves in diverse cultures with ease.',
      img: 'url(/industries/travel/ai-enhanced-language-translation-apps-for-travelers.jpg)',
      content:
        'Empower travelers to communicate effectively, navigate foreign environments, and immerse themselves in diverse cultures with ease using our AI-Enhanced Language Translation Apps for Travelers.',
      link: '/industries/travel/products/ai-enhanced-language-translation-apps-for-travelers',
    },
  ]